var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-layout-header", {
    class: [_vm.headerTheme, "admin-header"]
  }, [_c("div", {
    class: ["admin-header-wide", _vm.layout, _vm.pageWidth]
  }, [_vm.isMobile || _vm.layout === "head" ? _c("router-link", {
    class: ["logo", _vm.isMobile ? null : "pc", _vm.headerTheme],
    attrs: {
      to: "/"
    }
  }, [_c("img", {
    attrs: {
      width: "32",
      src: require("@/assets/img/logo.png")
    }
  }), !_vm.isMobile ? _c("h1", [_vm._v(_vm._s(_vm.systemName))]) : _vm._e()]) : _vm._e(), _vm.isMobile ? _c("a-divider", {
    attrs: {
      type: "vertical"
    }
  }) : _vm._e(), _vm.layout !== "head" ? _c("a-icon", {
    staticClass: "trigger",
    attrs: {
      type: _vm.collapsed ? "menu-unfold" : "menu-fold"
    },
    on: {
      click: _vm.toggleCollapse
    }
  }) : _vm._e(), _vm.layout !== "side" && !_vm.isMobile ? _c("div", {
    staticClass: "admin-header-menu",
    style: "width: ".concat(_vm.menuWidth, ";")
  }, [_c("i-menu", {
    staticClass: "head-menu",
    attrs: {
      theme: _vm.headerTheme,
      mode: "horizontal",
      options: _vm.menuData
    },
    on: {
      select: _vm.onSelect
    }
  })], 1) : _vm._e(), _c("div", {
    class: ["admin-header-right", _vm.headerTheme]
  }, [_c("header-notice", {
    staticClass: "header-item"
  }), _c("header-avatar", {
    staticClass: "header-item",
    on: {
      callEditPwd: _vm.callEditPwd
    }
  })], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };